import { useState } from "react";
import MyProcessesTable from "./MyProcessesTable";
import useMyProcesses from "./useMyProcesses";
import FilterDropdown from "~/components/FilterDropdown";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { Chip } from "primereact/chip";
const MyProcesses = ({ allEntities }) => {
  const {
    data,
    loading,
    isDataAvailable,
    totalRecord,
    onPageChange,
    rows,
    page,
    sortMeta,
    onSort,
    chipData,
    selectedFilters,
    setSelectedFilters,
    applyFilters,
    setSelectedValues,
    deSelectAll,
    serviceSubOptions,
    handleRemoveFilter,
    getStatus,
    getService,
    shouldHideServiceFilter,
    searchQuery,
    setSearchQuery,
  } = useMyProcesses({ allEntities });

  const createStatusOption = (name, code, color) => ({
    name,
    code,
    color,
    icon: () => (
      <span className="mr-2 process__status__badge">
        <StatusBadge
          status={{
            primary_color: color,
          }}
        />
      </span>
    ),
  });

  const filterOptions = [
    {
      name: "Status",
      id: "status",
      suboptions: [
        createStatusOption("Not Started", "not-started", "#757575"),
        createStatusOption("In Progress", "in-progress", "#326FD1"),
        createStatusOption("Completed", "completed", "#188A42"),
        createStatusOption("Overdue", "overdue", "#EAB308"),
      ],
    },
    ...(!shouldHideServiceFilter
      ? [
          {
            name: "Service Line",
            id: "service_line",
            suboptions: serviceSubOptions,
          },
        ]
      : []),
  ];
  return (
    <div className="my_processes--container border-gray mt-4">
      <p className="heading mb-3"> My Processes</p>
      <div className="flex justify-content-end mb-3">
        <div className="flex-1 mb-5">
          <div className="input-wrapper-container width__full">
            <span className="pi pi-search"></span>
            <input
              type="text"
              placeholder="Search by Process, Entity Name, Service Line or Country"
              className=" appearance-none outline-none w-full"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-content-end mb-3">
          <FilterDropdown
            groupedOptions={filterOptions}
            filterCount={chipData?.length}
            value={selectedFilters}
            onChange={(e) => {
              setSelectedValues(e.grouped);
              setSelectedFilters(e.value);
            }}
            applyFilter={applyFilters}
            deSelectAll={deSelectAll}
            placeholder="All events"
          />
        </div>
      </div>
      <div className="filter-chips-container mb-3">
        {chipData?.length ? `Filters (${chipData?.length})` : null}
        {chipData?.map((data) => (
          <Chip
            key={`${data?.category}-${data?.value}`}
            label={
              <span
                key={`${data?.category}-${data?.value}`}
                className="filter__chip"
              >
                {data?.category === "status" ? (
                  <span>
                    <span className="mr-2 process__status__badge">
                      <StatusBadge
                        status={{
                          primary_color: getStatus(data?.value)?.primary_color,
                        }}
                      />
                    </span>
                    {getStatus(data?.value)?.name}
                  </span>
                ) : (
                  getService(data?.value)?.name
                )}{" "}
                <span className="cross__icon">
                  <i
                    className="pi pi-times"
                    onClick={() => handleRemoveFilter(data)}
                  />
                </span>
              </span>
            }
            removable={false}
          />
        ))}
      </div>
      <MyProcessesTable
        data={data}
        loading={loading}
        isDataAvailable={isDataAvailable}
        totalRecords={totalRecord}
        onPageChange={onPageChange}
        rows={rows}
        page={page}
        sortMeta={sortMeta}
        onSort={onSort}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default MyProcesses;
